import { responsiveFontSizes, ThemeProvider } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { ptBR } from 'date-fns/locale';
import { PropsWithChildren } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { UserProvider } from '../../contexts/User.context';
import store from '../../shared/store/store';
import { muiTheme } from '../../shared/theme';
import { AuthenticationProvider } from '../features/authentication/authenticationContext';

const AppProviders = ({ children }: PropsWithChildren) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
      <ThemeProvider theme={responsiveFontSizes(muiTheme)}>
        <ReduxProvider store={store}>
          <BrowserRouter>
            <AuthenticationProvider>
              <UserProvider>{children}</UserProvider>
            </AuthenticationProvider>
          </BrowserRouter>
        </ReduxProvider>
      </ThemeProvider>
    </LocalizationProvider>
  );
};

export default AppProviders;
